import React, { useEffect } from "react";
import Footer from "../components/footer/Footer";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import AnalyticsSolutions from "../components/analyticsSolution/AnalyticsSolutions";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SecondFaq from "../components/secondFaq/SecondFaq";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import {
  AnalyticsHighvaluesData,
  AnalyticsWhoWeServeData,
  AnalyticsWhyChooseBitsclanData,
  DataAnalyticsTypesOfBuildData,
  DataAndAnalyticsServicesData,
  faqData,
  mainBannerImg,
  tabItems,
  tabs,
} from "../data/dataAnalyticsPageData";
import TypesOfBuild from "../components/types-of-build/TypesOfBuild";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import HighValues from "../components/high-values/HighValues";
import RoadMap from "../components/roadMap/RoadMap";
import { IndustryTabsData } from "../data/industriesTabsData";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import ContactSection from "../components/contactSection/ContactSection";
import { WebServicesIndustryTabsItemsData } from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";

const DataAndAnalytics = () => {
  const { t } = useTranslation("dataAndAnylyticsPage");
  const BannerContent = t("dataAnylyticsBanner", { returnObjects: true });
  const ServicesContent = t("dataAndAnylyticsServices", {
    returnObjects: true,
  });
  const typeOfBuildsContent = t("dataAndAnylyticsTypeOfBuild", {
    returnObjects: true,
  });
  const whoWeServeContent = t("dataAndAnylyticsWhoWeServe", {
    returnObjects: true,
  });
  const whyChooseUsContent = t("dataAndAnylyticsWhyChoseUs", {
    returnObjects: true,
  });
  const highValueFeatures = t("dataAndAnylyticsHighValueFeatures", {
    returnObjects: true,
  });
  const coverTheStackContent = t("dataAnalyticsCoverTheStackSection", {
    returnObjects: true,
  });
  const industriesHeading = t("dataAnalyticsIndustriesHeading", {
    returnObjects: true,
  });
  const faqSection = t("dataAnalyticsfaqSection", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("dataAnalyticsTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };
  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Unlock valuable insights with our data analytics services, turning complex data into actionable business strategies"
        />
      </Helmet>

      <MegaMenu />

      <div className="data-and-analytics">
        <SimilerBanner
          diffBannerBackgroundImage={mainBannerImg}
          mainHeading={BannerContent?.mainHeading}
          greenHeading={BannerContent?.greenHeading}
          subHeading={BannerContent?.subHeadingGreen}
          content={BannerContent?.sectionDescription}
          btnText2={BannerContent?.bannerButtonText}
          sideImage=""
        />
      </div>

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <DevelopmentServices
        tabs={ServicesContent?.DataAndAnalyticsServicesDataTabs}
        heading={
          ServicesContent?.DataAndAnalyticsServicesDataContent?.mainHeading
        }
        subheading={
          ServicesContent?.DataAndAnalyticsServicesDataContent
            ?.sectionDescription
        }
      />

      <TypesOfBuild
        typeOfApps={typeOfBuildsContent?.typeOfApps}
        heading={typeOfBuildsContent?.heading}
        sideImage="data-and-anylytics.avif"
      />

      <AnalyticsSolutions />

      <WhoWeServe
        cardContent={whoWeServeContent?.cardsContent}
        heading={whoWeServeContent?.sectionContent?.heading}
        subHeading={whoWeServeContent?.sectionContent?.description}
      />

      <WhyChooseBitsclan
        tabs={whyChooseUsContent?.tabsData}
        heading={whyChooseUsContent?.sectionContent?.mainHeading}
        subheading={whyChooseUsContent?.sectionContent?.sectionDescription}
      />

      <HighValues
        heading={highValueFeatures?.mainHeading}
        subHeading={highValueFeatures?.sectionDescription}
        boxContent={highValueFeatures?.highValueCardData}
        btnLink="#"
        btnText={highValueFeatures?.buttonText}
      />

      {/* <NewEngagementModels /> */}
      <SimpleModels content={engagementModelsContent} />

      <RoadMap roadMapsteps={[]} roadMapHeading={[]} />

      <CoverTheStack
        whereStart={coverTheStackContent?.sectionContent?.defaultTabOpen}
        mainHeading={coverTheStackContent?.sectionContent?.mainHeading}
        subHeading={coverTheStackContent?.sectionContent?.sectionDescription}
        tabs={coverTheStackContent?.tabs}
        tabItems={coverTheStackContent?.tabItems}
      />

      <IndustriesTabs mainheading={industriesHeading?.mainHeading} />

      <DevelopingSolution heading="We Make Success Stories" />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="data-analytics"
      />

      <SecondFaq
        faqs={faqSection?.questionAndAnswer}
        mainHeading={faqSection?.sectionContent?.mainHeading}
        subHeading={faqSection?.sectionContent?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default DataAndAnalytics;
